export const DASHBOARD_SEARCH_SET = 'DASHBOARD_SEARCH_SET';